var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white h-full"},[_c('div',{staticClass:"p-4"},[_c('h2',{staticClass:"fs-20 font-bold uppercase"},[_vm._v(_vm._s(_vm.$t('Chương trình tích điểm')))]),_c('HodoCreditLayout',{attrs:{"type":_vm.HODO_CREDIT_TYPE.accumulate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }